import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _path from 'ramda/src/path';
import SearchListing from '../../API/SearchListing';
import FeaturedListingTile from './FeaturedListingTile';
import GeneralUtility from '../../utilities/generalUtility';


const FeaturedListingContainer = (props) => {
	const [listingsJson, setListingsJson] = useState([]);
	const params = { RecordCount: "3", WebsiteId: props.websiteId, ShowSold: true, FeaturedOnly: true, ImageSize: 3 };

	// runs once similar to componentDidMount
	useEffect(() => {
		SearchListing.browse(params)
			.then(response => {
				if (!_path(['data', 'SearchListingResult', 'Success'], response)) {
					throw _path(['data', 'SearchListingResult', 'Message'], response);
				}
				setListingsJson(response.data.SearchListingResult.Data);

				// update external page styling if featured listings exist
				const featuredListingsLength = response.data.SearchListingResult.Data.length;
				if (featuredListingsLength > 0) {
					const sidebarContainer = document.querySelector('.col_sidebar_holder');
					if (sidebarContainer) {
						sidebarContainer.classList.add("has-featured-listings");
						if (featuredListingsLength === 3) {
							sidebarContainer.classList.add("extend-to-sidebar");
						}
					}
				}
			})
			.catch(error => {
				GeneralUtility.logWebRequestFailure(error, `fetch featured listings on profile page`);
			});
	}, []);

	if (listingsJson.length < 1) {
		return null;
	}

	return (
		<React.Fragment>
			<ul data-testid="featuredListingContainer">
			{listingsJson.map(listing => {
				const uniqueKey = listing.UniqueKey;
				return (
					<FeaturedListingTile key={uniqueKey} data={listing} />
				);
			})}
			</ul>
		</React.Fragment>
	);
};
		
		
FeaturedListingContainer.propTypes = {
	websiteId: PropTypes.string
};

export default FeaturedListingContainer;
